<template>
	<div class="wrong">
		<img src="../../assets/img/none/400.png" alt="">
	</div>
</template>

<script>

  export default {
		name: "404",
		data() {

		},
		methods:{
			gohome(){
				this.$router.push('/index')
			}
		}
	}
</script>

<style lang="less" scoped>
	.wrong{
		width: 100%;
		height: 900px;
		background-color: #f5f5f5;
		
		img{
			display: block;
			width: 50%;
			margin: 0 auto;
			// height: ;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/index/404.vue